import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Box,
  IconButton,
  TextField,
  Divider,
  InputAdornment,
  Typography,
  Button, Modal, Checkbox, FormControlLabel, Grid,
} from "@mui/material";
import { useOutletContext, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { esignToolApi } from "../../services/esignApi";
import { pdfToolApi } from "../../services/PdfEditor/pdfToolApi";
import { esignIcons } from "../Esign/icons";
import { getStatusStyles } from "../../heplers";
import { setUploadedDocument, clearUploadedDocument } from "../../store/reducers/uploadDocumentSlice";
import Loader from "../Loader";

const SignersTable = ({filteredDocs, fetchAllSigners, setPreviewOpen, previewOpen, setUpdateSigner, updateSigner, page, setPage}) => {
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const { open } = useOutletContext();
    const [deleteSignerOpen, setDeleteSignerOpen] = useState(false);
    const [selectedSigner, setSelectedSigner] = useState(null);
    const [signername, setSignerName] = useState("");
    const [signeremail, setSignerEmail] = useState("");
    const [singerNumber, setSignerNumber] = useState("");
    const [singerPlace, setSignerPlace] = useState("");
    const [signerReason, setSignerReason] = useState("");
    const [signerOtherReason, setSignerOtherReason] = useState("");

    const [errors, setErrors] = useState({ signername: "", signeremail: "", singerNumber: "", singerPlace: "", signerReason: "", signerOtherReason: "" });
    const [helperText, setHelperText] = useState({ signername: "", signeremail: "", singerNumber: "", singerPlace: "", signerReason: "", signerOtherReason: "" });

    const handleEdit = (signer) => {
        setSelectedSigner(signer);
    };

    useEffect(() => {
        if (selectedSigner && !deleteSignerOpen) {
            setSignerName(selectedSigner.name)
            setSignerEmail(selectedSigner.email)
            setSignerNumber(selectedSigner.phone)
            setSignerPlace(selectedSigner.place)
            setSignerReason(selectedSigner.reason)
            setSignerOtherReason(selectedSigner.other_reason_value)
            setPreviewOpen(true);
            setUpdateSigner(true);
        }
    }, [selectedSigner]);

    const validateEmail = (value) => {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailPattern.test(value);
    };

    const validatePhoneNumber = (value) => {
        const phonePattern = /^[6-9]\d{9}$/;
        return phonePattern.test(value);
    };

    const validateSignerData = () => {
        const errors = {};
        if (!signername) errors.signername = "Name is required.";
        if (!signeremail) {
            errors.signeremail = "Email is required.";
        } else if (!validateEmail(signeremail)) {
            errors.signeremail = "Invalid email address.";
        }
    
        if (!singerNumber) {
            errors.singerNumber = "Phone number is required.";
        } else if (!validatePhoneNumber(singerNumber)) {
            errors.singerNumber = "Enter a valid 10-digit mobile number starting with 6-9.";
        }

        if (!singerPlace) errors.singerPlace = "Place is required.";

        if (!signerReason) {
            errors.signerReason = "Reason is required.";
        } else if (signerReason.toLowerCase() === "other" && !signerOtherReason) {
            errors.signerOtherReason = "Specify Other Reason.";
        }
    
        if (Object.keys(errors).length) {
            setErrors(errors);
            setHelperText(errors);
            return false;
        }
        return true;
    };

    const resetSignerForm = () => {
        setSelectedSigner(null);
        setSignerName("");
        setSignerEmail("");
        setSignerNumber("");
        setSignerPlace("");
        setSignerReason("");
        setSignerOtherReason("");
        setPreviewOpen(false);
    };

    const handleAddOrUpdateSigners = async (isUpdate) => {
        if (!validateSignerData()) return;

        const signerData = {
            id: isUpdate ? selectedSigner.id : undefined,
            name: signername,
            email: signeremail,
            phone: singerNumber,
            place: singerPlace,
            reason: signerReason,
            other_reason_value: signerOtherReason,
        };
        try {
            const response = isUpdate
                ? await esignToolApi.updateFrequentSigner(signerData)
                : await esignToolApi.addFrequentSigner(signerData);
            
            console.log(`${isUpdate ? "Updated" : "Saved"} Signer Response:`, response);
            resetSignerForm();
            fetchAllSigners();
        } catch (error) {
            console.error("Error saving/updating draft:", error);
        }
    };

    const handleDelete = (signer) => {
        setDeleteSignerOpen(true);
        setSelectedSigner(signer);
    };

    const handleDeleteSigners = async () => {
        try {
            const response = await esignToolApi.deleteFrequentSigner(selectedSigner.id);
            if (response && response.status===200) {
                setDeleteSignerOpen(false);
                setSelectedSigner(null);
                fetchAllSigners();
            } else {
                console.error("Failed to delete signer:", response);
            }
        } catch (error) {
            console.error("Error deleting signer:", error);
        }
    }; 

  return (
    <>
        {filteredDocs.length > 0 && (
        <Paper sx={{ width: "100%", overflow: "auto", boxShadow: "none", height: "90%", mt: "15px" }}>
            <TableContainer>
                <Table>
                <TableHead sx={{ background: "#F5F5F5", fontSize: "15px", fontWeight: 500, color: "#1D1D1D" }}>
                    <TableRow>
                    <TableCell sx={{  pl: "30px", }}>S. No.</TableCell>
                    <TableCell>Signer name</TableCell>
                    <TableCell>Email Address</TableCell>
                    <TableCell>Phone Number</TableCell>
                    <TableCell>Location</TableCell>
                    <TableCell>Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody sx={{ color: "#202224", fontSize: "15px", fontWeight: 400 }}>
                    {console.log(filteredDocs)}
                    {filteredDocs.length > 0 && (
                        [...filteredDocs]
                        // .reverse()
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row, index) => (
                            <TableRow
                                key={row.id}
                                sx={{ "&:hover": { backgroundColor: "#f5f5f5" } }}
                                >
                                <TableCell sx={{ pl: "30px", cursor: "pointer", maxWidth: "50px" }}>
                                    {(page * rowsPerPage + index + 1).toString().padStart(2, "0")}
                                </TableCell>

                                <TableCell
                                    sx={{
                                    cursor: "pointer",
                                    maxWidth: "150px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    }}
                                    title={row.name}
                                >
                                    {row.name}
                                </TableCell>

                                <TableCell
                                    sx={{
                                    cursor: "pointer",
                                    maxWidth: "200px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    }}
                                    title={row.email}
                                >
                                    {row.email}
                                </TableCell>

                                <TableCell
                                    sx={{
                                    cursor: "pointer",
                                    maxWidth: "130px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    }}
                                    title={row.phone}
                                >
                                    {row.phone}
                                </TableCell>

                                <TableCell
                                    sx={{
                                    cursor: "pointer",
                                    maxWidth: "150px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    }}
                                    title={row.place}
                                >
                                    {row.place}
                                </TableCell>

                                <TableCell onClick={(e) => e.stopPropagation()} sx={{ maxWidth: "100px" }}>
                                    <IconButton onClick={() => handleEdit(row)}>
                                    {esignIcons.editIconBlue}
                                    </IconButton>
                                    <IconButton onClick={() => handleDelete(row)}>
                                    {esignIcons.deleteIconRed}
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))
                    )}
                </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[]}
                component="div"
                count={filteredDocs.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={(_, newPage) => setPage(newPage)}
                />
        </Paper>
        )}
        <Modal open={previewOpen} onClose={() => {setPreviewOpen(false); resetSignerForm();}}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "720px",
                    maxHeight: "600px",
                    backgroundColor: "#fff",
                    boxShadow: 24,
                    overflow: "auto",
                    borderRadius: "20px",
                }}
            >
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: "20px 30px" }}>
                    <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: 600, color: "#1D1D1D" }}>{updateSigner ? "Edit Signer" : "Add Signer"}</Typography>
                </Box>
                <Divider sx={{ borderWidth : "1px", margin: 0, padding: 0 }} />

                <Box sx={{ p: "20px 30px" }}>
                    <Box sx={{ display: "flex", gap: 2, mb: 3, justifyContent: "space-between" }}>
                        <Box width={"315px"}>
                            <TextField
                                placeholder="Name*"
                                type="text"
                                variant="outlined"
                                fullWidth
                                value={signername}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^[a-zA-Z\s]*$/.test(value)) {
                                        setSignerName(value);
                                        setErrors((prevErrors) => ({ ...prevErrors, signername: "" }));
                                        setHelperText((prevHelperText) => ({ ...prevHelperText, signername: "" }));
                                    }
                                }}
                                error={!!errors.signername}
                                sx={{
                                boxSizing: "border-box",
                                borderRadius: "10px",
                                backgroundColor: "#fff",
                                borderColor: "#C0C0C0",
                                borderWidth: "5px",
                                "& .MuiOutlinedInput-root": {
                                    borderColor: errors.signername ? "#FF6666" : "#C0C0C0",
                                    backgroundColor: errors.signername ? "#FFF1F1" : "none",
                                    "&:hover fieldset": {
                                    borderColor: errors.signername ? "#FF6666" : "#C0C0C0",
                                    },
                                    "&.Mui-focused fieldset": {
                                    borderColor: errors.signername ? "#FF6666" : "#C0C0C0",
                                    },
                                },
                                "& .MuiFormHelperText-root": {
                                    color: "#FF6666",
                                },
                                }}
                                InputProps={{
                                sx: { 
                                    borderRadius: "10px",
                                    height: 46,
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    "& input::-ms-reveal, & input::-ms-clear": {
                                        display: "none",
                                    },
                                },
                                }}
                                inputProps={{ maxLength: 50 }}
                            />
                            
                            {!! errors.signername && (
                                <Typography
                                sx={{
                                    color: "#FF6666",
                                    fontSize: "12px",
                                    mt: 0.5,
                                    mb: 0,
                                    marginRight: "auto"
                                }}
                                >
                                {helperText.signername}
                                </Typography>
                            )}
                        </Box>
                        <Box width={"315px"}>
                            <TextField
                                placeholder="Email*"
                                type="email"
                                variant="outlined"
                                fullWidth
                                value={signeremail}
                                onChange={(e) => {
                                setSignerEmail(e.target.value)
                                setErrors((prevErrors) => ({ ...prevErrors, signeremail: "" }));
                                setHelperText((prevHelperText) => ({ ...prevHelperText, signeremail: "" }))
                            }}
                                error={!!errors.signeremail}
                                sx={{
                                boxSizing: "border-box",
                                borderRadius: "10px",
                                backgroundColor: "#fff",
                                borderColor: "#C0C0C0",
                                borderWidth: "5px",
                                "& .MuiOutlinedInput-root": {
                                    borderColor: errors.signeremail ? "#FF6666" : "#C0C0C0",
                                    backgroundColor: errors.signeremail ? "#FFF1F1" : "none",
                                    "&:hover fieldset": {
                                    borderColor: errors.signeremail ? "#FF6666" : "#C0C0C0",
                                    },
                                    "&.Mui-focused fieldset": {
                                    borderColor: errors.signeremail ? "#FF6666" : "#C0C0C0",
                                    },
                                },
                                "& .MuiFormHelperText-root": {
                                    color: "#FF6666",
                                },
                                }}
                                InputProps={{
                                sx: { 
                                    borderRadius: "10px",
                                    height: 46,
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    "& input::-ms-reveal, & input::-ms-clear": {
                                        display: "none",
                                    },
                                },
                                }}
                                inputProps={{ maxLength: 100 }}
                            />
                            
                            {!! errors.signeremail && (
                                <Typography
                                sx={{
                                    color: "#FF6666",
                                    fontSize: "12px",
                                    mt: 0.5,
                                    mb: 0,
                                    marginRight: "auto"
                                }}
                                >
                                {helperText.signeremail}
                                </Typography>
                            )}
                        </Box>
                    </Box>

                    <Box sx={{ display: "flex", gap: 2, mb: 3, justifyContent: "space-between" }}>
                        <Box width={"315px"}>
                            <TextField
                                placeholder="Mobile*"
                                type="number"
                                variant="outlined"
                                fullWidth
                                value={singerNumber}
                                onKeyDown={(e) => {
                                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                                      e.preventDefault();
                                    }
                                }}
                                onPaste={(e) => {
                                    const paste = e.clipboardData.getData('text');
                                    if (!/^\d+$/.test(paste)) {
                                      e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    const inputValue = e.target.value.slice(0, 10);
                                    setSignerNumber(inputValue);
                                    setErrors((prevErrors) => ({ ...prevErrors, singerNumber: "" }));
                                    setHelperText((prevHelperText) => ({ ...prevHelperText, singerNumber: "" }))
                                }}
                                error={!!errors.singerNumber}
                                sx={{
                                boxSizing: "border-box",
                                borderRadius: "10px",
                                backgroundColor: "#fff",
                                borderColor: "#C0C0C0",
                                borderWidth: "5px",
                                "& .MuiOutlinedInput-root": {
                                    borderColor: errors.singerNumber ? "#FF6666" : "#C0C0C0",
                                    backgroundColor: errors.singerNumber ? "#FFF1F1" : "none",
                                    "&:hover fieldset": {
                                    borderColor: errors.singerNumber ? "#FF6666" : "#C0C0C0",
                                    },
                                    "&.Mui-focused fieldset": {
                                    borderColor: errors.singerNumber ? "#FF6666" : "#C0C0C0",
                                    },
                                },
                                "& .MuiFormHelperText-root": {
                                    color: "#FF6666",
                                },
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start" sx={{ height: "46px", paddingRight: "12px", borderRight: "1px solid #C0C0C0", maxHeight: "46px", }}>
                                            <Typography
                                                sx={{
                                                    color: "#1D1D1D",
                                                    fontSize: "16px",
                                                    fontWeight: 500,
                                                    transition: "color 0.2s ease-in-out",
                                                    textDecoration: "none",
                                                }}
                                                >
                                                +91
                                            </Typography>
                                        </InputAdornment>
                                    ),
                                    sx: { 
                                        borderRadius: "10px",
                                        height: 46,
                                        fontSize: "16px",
                                        fontWeight: "500",
                                        "& input::-ms-reveal, & input::-ms-clear": {
                                            display: "none",
                                        },
                                        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                            display: "none",
                                            WebkitAppearance: "none",
                                            margin: 0,
                                        },
                                        "& input[type=number]": {
                                            MozAppearance: "textfield",
                                        },
                                    },
                                }}
                            />
                            {!! errors.singerNumber && (
                                <Typography
                                sx={{
                                    color: "#FF6666",
                                    fontSize: "10px",
                                    mt: 0.5,
                                    mb: 0,
                                    marginRight: "auto"
                                }}
                                >
                                {helperText.singerNumber}
                                </Typography>
                            )}
                        </Box>
                        <Box width={"315px"}>
                            <TextField
                                placeholder="Place*"
                                type="text"
                                variant="outlined"
                                fullWidth
                                value={singerPlace}
                                onChange={(e) => {
                                setSignerPlace(e.target.value)
                                setErrors((prevErrors) => ({ ...prevErrors, singerPlace: "" }));
                                setHelperText((prevHelperText) => ({ ...prevHelperText, singerPlace: "" }))
                            }}
                                error={!!errors.singerPlace}
                                sx={{
                                boxSizing: "border-box",
                                borderRadius: "10px",
                                backgroundColor: "#fff",
                                borderColor: "#C0C0C0",
                                borderWidth: "5px",
                                "& .MuiOutlinedInput-root": {
                                    borderColor: errors.singerPlace ? "#FF6666" : "#C0C0C0",
                                    backgroundColor: errors.singerPlace ? "#FFF1F1" : "none",
                                    "&:hover fieldset": {
                                    borderColor: errors.singerPlace ? "#FF6666" : "#C0C0C0",
                                    },
                                    "&.Mui-focused fieldset": {
                                    borderColor: errors.singerPlace ? "#FF6666" : "#C0C0C0",
                                    },
                                },
                                "& .MuiFormHelperText-root": {
                                    color: "#FF6666",
                                },
                                }}
                                InputProps={{
                                    sx: { 
                                        borderRadius: "10px",
                                        height: 46,
                                        fontSize: "16px",
                                        fontWeight: "500",
                                        "& input::-ms-reveal, & input::-ms-clear": {
                                            display: "none",
                                        },
                                    },
                                }}
                                inputProps={{ maxLength: 50 }}
                            />
                            {!! errors.singerPlace && (
                                <Typography
                                sx={{
                                    color: "#FF6666",
                                    fontSize: "10px",
                                    mt: 0.5,
                                    mb: 0,
                                    marginRight: "auto"
                                }}
                                >
                                {helperText.singerPlace}
                                </Typography>
                            )}
                        </Box>
                    </Box>

                    <Box sx={{ display: "flex", gap: 2, justifyContent: "space-between" }}>
                        <Box width={"315px"}>
                            <TextField
                                select
                                variant="outlined"
                                fullWidth
                                value={signerReason}
                                onChange={(e) => {
                                    setSignerReason(e.target.value)
                                    setErrors((prevErrors) => ({ ...prevErrors, signerReason: "" }));
                                    setHelperText((prevHelperText) => ({ ...prevHelperText, signerReason: "" }))
                                }}
                                SelectProps={{ native: true }}
                                sx={{
                                    boxSizing: "border-box",
                                    borderRadius: "10px",
                                    backgroundColor: "#fff",
                                    borderColor: "#C0C0C0",
                                    borderWidth: "5px",
                                    "& .MuiOutlinedInput-root": {
                                        borderColor: errors.signerReason ? "#FF6666" : "#C0C0C0",
                                        backgroundColor: errors.signerReason ? "#FFF1F1" : "none",
                                        "&:hover fieldset": {
                                        borderColor: errors.signerReason ? "#FF6666" : "#C0C0C0",
                                        },
                                        "&.Mui-focused fieldset": {
                                        borderColor: errors.signerReason ? "#FF6666" : "#C0C0C0",
                                        },
                                    },
                                    "& .MuiFormHelperText-root": {
                                        color: "#FF6666",
                                    },
                                }}
                                InputProps={{
                                    sx: { 
                                        borderRadius: "10px",
                                        height: 46,
                                        fontSize: "16px",
                                        fontWeight: "500",
                                        "& input::-ms-reveal, & input::-ms-clear": {
                                            display: "none",
                                        },
                                    },
                                }}
                            >
                                <option value="">Select reason for esign</option>
                                <option value="KYC">KYC</option>
                                <option value="Account Opening">Account Opening</option>
                                <option value="Agreement">Agreement</option>
                                <option value="Other">Other</option>
                            </TextField>
                            {!! errors.signerReason && (
                                <Typography
                                sx={{
                                    color: "#FF6666",
                                    fontSize: "10px",
                                    mt: 0.5,
                                    mb: 0,
                                    marginRight: "auto"
                                }}
                                >
                                {helperText.signerReason}
                                </Typography>
                            )}
                        </Box>
                        {signerReason.toLowerCase() === "other" && (
                            <Box width={"315px"}>
                                <TextField
                                    placeholder="Write reason here..."
                                    type="text"
                                    variant="outlined"
                                    fullWidth
                                    value={signerOtherReason}
                                    onChange={(e) => {
                                    setSignerOtherReason(e.target.value)
                                    setErrors((prevErrors) => ({ ...prevErrors, signerOtherReason: "" }));
                                    setHelperText((prevHelperText) => ({ ...prevHelperText, signerOtherReason: "" }))
                                }}
                                    error={!!errors.signerOtherReason}
                                    sx={{
                                        boxSizing: "border-box",
                                        borderRadius: "10px",
                                        backgroundColor: "#fff",
                                        borderColor: "#C0C0C0",
                                        borderWidth: "5px",
                                        "& .MuiOutlinedInput-root": {
                                            borderColor: errors.signerOtherReason ? "#FF6666" : "#C0C0C0",
                                            backgroundColor: errors.signerOtherReason ? "#FFF1F1" : "none",
                                            "&:hover fieldset": {
                                            borderColor: errors.signerOtherReason ? "#FF6666" : "#C0C0C0",
                                            },
                                            "&.Mui-focused fieldset": {
                                            borderColor: errors.signerOtherReason ? "#FF6666" : "#C0C0C0",
                                            },
                                        },
                                        "& .MuiFormHelperText-root": {
                                            color: "#FF6666",
                                        },
                                    }}
                                    InputProps={{
                                        sx: { 
                                            borderRadius: "10px",
                                            height: 46,
                                            fontSize: "16px",
                                            fontWeight: "500",
                                            "& input::-ms-reveal, & input::-ms-clear": {
                                                display: "none",
                                            },
                                        },
                                    }}
                                    inputProps={{ maxLength: 100 }}
                                />
                                {!! errors.signerOtherReason && (
                                    <Typography
                                    sx={{
                                        color: "#FF6666",
                                        fontSize: "10px",
                                        mt: 0.5,
                                        mb: 0,
                                        marginRight: "auto"
                                    }}
                                    >
                                    {helperText.signerOtherReason}
                                    </Typography>
                                )}
                            </Box>
                        )}
                    </Box>
                </Box> 
                    
                <Divider sx={{ borderWidth : "1px", }} />
                    
                <Box sx={{ p: "0 30px", mb: "15px"}}>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: "15px", gap: 2 }}>
                        <Button variant="contained" sx={{ width: '130px', height: 46, color: "#1D1D1D", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #D2D2D2", boxShadow: "none", fontWeight: "500",}}  onClick={() => {setPreviewOpen(false); resetSignerForm();}} >
                            Cancel
                        </Button>
                        <Button variant="contained" sx={{ width: '155px', height: 46, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", "&:disabled": {background: "#E4E4E4", color: "#ffffff", borderColor: "#E4E4E4"} }} onClick={() => updateSigner ? handleAddOrUpdateSigners(true) : handleAddOrUpdateSigners(false)} >
                            {updateSigner ? "Update" : "Add"}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>

        <Modal open={deleteSignerOpen} onClose={() => setDeleteSignerOpen(false)}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "434px",
                    height: "368px",
                    backgroundColor: "#fff",
                    boxShadow: 24,
                    overflow: "auto",
                    borderRadius: "20px",
                }}
            >
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: "1em 1em  1em 2em" }}>
                    <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: 600, color: "#1D1D1D" }}>Delete Signer</Typography>
                </Box>
                <Divider sx={{ borderWidth : "1px", margin: 0, padding: 0 }} />
                <Box sx={{ p: "1em 2em", mb: 3, display: "flex", flexDirection: "column", justifyContent: "space-between", height: "74%" }}>
                    <Box>
                        <img src={`${process.env.PUBLIC_URL}/images/delete.gif`} alt="delete" style={{ height: 83 }} />
                    </Box>
                    <Typography variant="p" sx={{ fontSize: "20px", fontWeight: 400, color: "#1D1D1D" }}>Are you sure you want to delete this signer?</Typography>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mt: "auto", gap: 2 }}>
                        <Button variant="contained" sx={{ width: '171px', height: 46, color: "#1D1D1D", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #D2D2D2", boxShadow: "none", fontWeight: "500",}}  onClick={() => {setDeleteSignerOpen(false); resetSignerForm();}} >
                            No
                        </Button>
                        <Button variant="contained" sx={{ width: '171px', height: 46, color: "#ffffff", background: "#C5060B", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #C5060B", boxShadow: "none", fontWeight: "500",}} onClick={handleDeleteSigners}  >
                            Delete
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    </>
  );
};

export default SignersTable;
